import { NgModule } from '@angular/core';

import { ThfModalPasswordRecoveryModule } from './thf-modal-password-recovery/thf-modal-password-recovery.module';
import { ThfPageBackgroundModule } from './thf-page-background/thf-page-background.module';
import { ThfPageBlockedUserModule } from './thf-page-blocked-user/thf-page-blocked-user.module';
import { ThfPageChangePasswordModule } from './thf-page-change-password/thf-page-change-password.module';
import { ThfPageDynamicDetailModule } from './thf-page-dynamic-detail/thf-page-dynamic-detail.module';
import { ThfPageDynamicEditModule } from './thf-page-dynamic-edit/thf-page-dynamic-edit.module';
import { ThfPageDynamicSearchModule } from './thf-page-dynamic-search/thf-page-dynamic-search.module';
import { ThfPageDynamicTableModule } from './thf-page-dynamic-table/thf-page-dynamic-table.module';
import { ThfPageJobSchedulerModule } from './thf-page-job-scheduler/thf-page-job-scheduler.module';
import { ThfPageLoginModule } from './thf-page-login/thf-page-login.module';

@NgModule({
  imports: [
    ThfModalPasswordRecoveryModule,
    ThfPageBackgroundModule,
    ThfPageBlockedUserModule,
    ThfPageChangePasswordModule,
    ThfPageDynamicDetailModule,
    ThfPageDynamicEditModule,
    ThfPageDynamicSearchModule,
    ThfPageDynamicTableModule,
    ThfPageJobSchedulerModule,
    ThfPageLoginModule
  ],
  exports: [
    ThfModalPasswordRecoveryModule,
    ThfPageBackgroundModule,
    ThfPageBlockedUserModule,
    ThfPageChangePasswordModule,
    ThfPageDynamicDetailModule,
    ThfPageDynamicEditModule,
    ThfPageDynamicSearchModule,
    ThfPageDynamicTableModule,
    ThfPageJobSchedulerModule,
    ThfPageLoginModule
  ]
})
export class ThfComponentsModule { }
